import { styled } from '@mui/material/styles';

import TableCell, { tableCellClasses } from "@mui/material/TableCell";

const StyledTableCell = styled(TableCell)(
    ({ theme }) => ({
        borderBottom: '1px solid' + theme.palette.border.drawer,
        [`&.${tableCellClasses.sizeSmall}`]: {
            padding: theme.spacing(0.5, 1),
            fontSize: 14,
        },
        [`&.${tableCellClasses.head}`]: {
            fontWeight: 'bold',
            color: theme.palette.text.secondary,
            backgroundColor: theme.palette.background.tablePrimary,
        },
        [`&.${tableCellClasses.sizeSmall}.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.background.tab,
        },
        [`&.${tableCellClasses.body}`]: {

        },
    })
);

export default StyledTableCell;
